<template>
    <div class="exam-result-management">
        <h3>시스템 설정 > API 및 연동 설정</h3>

            <!-- API 발급 및 관리 -->
            <div class="setting-card">
                <div class="card-title">API 발급 및 관리</div>
                <div class="api-list">
                    <div class="input-row" v-for="(key, idx) in apiKeys" :key="idx">
                        <label class="input-label">API Key</label>
                        <input class="input" type="text" v-model="apiKeys[idx].api_key"  :readonly="!apiKeys[idx].editable" />
                        <button class="icon-btn" @click="removeApiKey(key.id)" :disabled="!apiKeys[idx].editable"  v-if="apiKeys.length > 1" aria-label="API Key 삭제">
                            <span class="icon-minus"></span>
                        </button>
                        <button class="small-btn"  @click="toggleEditApiKey(idx)"  v-if="apiKeys.length > 1">{{ apiKeys[idx].editable ? '수정중' : '수정' }}</button>
                    </div>
                    <div>
                        <button class="add-btn" @click="addApiKey">추가</button>
                        <button class="add-btn" @click="saveApiKeys">저장</button>
                    </div>
                </div>
            </div>

            <!-- 토큰 설정 -->
            <div class="setting-card">
                <div class="card-title">토큰 설정</div>
                <div class="token-row" v-for="(key, idx) in tokens" :key="idx">
                    <label class="input-label">Token</label>
                    <input class="input" type="text" v-model="tokens[idx].token" :readonly="!tokens[idx].editable"/>
                    <button class="icon-btn" @click="removeToken(key.id)" :disabled="!tokens[idx].editable"  v-if="tokens.length > 1" aria-label="tokens 삭제">
                        <span class="icon-minus"></span>
                    </button>
                    <button class="small-btn"  @click="toggleEditToken(idx)"  v-if="tokens.length > 1">{{ tokens[idx].editable ? '수정중' : '수정' }}</button>
                </div>
                <div>
                    <button class="add-btn" @click="addToken">추가</button>
                    <button class="add-btn" @click="saveToken">저장</button>
                </div>
            </div>

    </div>
</template>

<script>
import api, {urls} from '@/api'

export default {
    data() {
        return {
            apiKeys: [],
            tokens: [],

        };
    },
    methods: {
        getdate() {
            api.get(urls.system.apiKeyData)
                .then((resApi) => {
                    this.apiKeys = (resApi.data.list || []).map(item => ({
                        ...item,
                        editable: false,
                    }));

                    return api.get(urls.system.tokenData);
                })
                .then((resToken) => {
                    this.tokens = (resToken.data.list || []).map(item => ({
                        ...item,
                        editable: false,
                    }));
                })
                .catch((error) => {
                    alert('데이터 불러오기 실패');
                    console.error(error);
                });
        },

        removeApiKey(id) {
            api.post(urls.system.apiKeyDelete, { id: id })
                .then((res) => {
                    const data = res.data;

                    if (data === 1) {
                        alert('API_Key 삭제 성공했습니다.');
                        this.getdate();
                    } else {
                        this.error = data.message || 'API_Key 삭제에 실패하였습니다.';
                        alert(this.error);
                    }
                })
                .catch((error) => {
                    alert('API_Key 삭제 기능이 실패했습니다.');
                    console.error(error);
                });
        },

        toggleEditApiKey(idx) {
            const keyItem = this.apiKeys[idx];
            if (keyItem.editable) {
                // 현재 편집 중이면 저장 처리
                // this.saveApiKey(idx);
            } else {
                // 편집 모드 켜기 - 직접 속성 추가/변경
                this.apiKeys[idx].editable = true;
            }
        },

        addApiKey() {
            this.apiKeys.push({ api_key: '' });
        },

        saveApiKeys() {
            const modifiedKeys = this.apiKeys.filter(key => key.editable);

            if (modifiedKeys.length === 0) {
                alert('저장할 수정 중인 API Key가 없습니다.');
                return;
            }

            const requests = modifiedKeys.map(keyItem => {
                if (keyItem.id != null) {
                    return api.post(urls.system.apiKeyUpdate, { id: keyItem.id, api_key: keyItem.api_key });
                } else {
                    return api.post(urls.system.apiKeyInsert, { api_key: keyItem.api_key });
                }
            });

            Promise.all(requests)
                .then((responses) => {
                    const allSuccess = responses.every(res => res.data === 1);

                    if (allSuccess) {
                        alert('수정 중인 API Key 저장 완료');
                        this.getdate();
                    } else {
                        alert('일부 API Key 저장에 실패했습니다.');
                    }
                })
                .catch((error) => {
                    alert('저장 중 오류 발생');
                    console.error(error);
                });
        },


        removeToken(id) {
            api.post(urls.system.tokenDelete, { id: id })
                .then((res) => {
                    const data = res.data;

                    if (data === 1) {
                        alert('Token 삭제 성공했습니다.');
                        this.getdate();
                    } else {
                        this.error = data.message || 'Token 삭제에 실패하였습니다.';
                        alert(this.error);
                    }
                })
                .catch((error) => {
                    alert('Token 삭제 기능이 실패했습니다.');
                    console.error(error);
                });
        },

        toggleEditToken(idx) {
            const tokenItem = this.tokens[idx];
            if (tokenItem.editable) {
                // 현재 편집 중이면 저장 처리
                // this.saveApiKey(idx);
            } else {
                // 편집 모드 켜기 - 직접 속성 추가/변경
                this.tokens[idx].editable = true;
            }
        },
        addToken() {
            this.tokens.push({ token: '' });
        },

        saveToken() {
            const modifiedTokens = this.tokens.filter(token => token.editable);

            if (modifiedTokens.length === 0) {
                alert('저장할 수정 중인 Token이 없습니다.');
                return;
            }

            const requests = modifiedTokens.map(tokenItem => {
                if (tokenItem.id != null) {
                    return api.post(urls.system.tokenUpdate, { id: tokenItem.id, token: tokenItem.token });
                } else {
                    return api.post(urls.system.tokenInsert, { token: tokenItem.token });
                }
            });

            Promise.all(requests)
                .then((responses) => {
                    const allSuccess = responses.every(res => res.data === 1);

                    if (allSuccess) {
                        alert('수정 중인 Token 저장 완료');
                        this.getdate();
                    } else {
                        alert('일부 Token 저장에 실패했습니다.');
                    }
                })
                .catch((error) => {
                    alert('저장 중 오류 발생');
                    console.error(error);
                });
        },


    },
    mounted() {
        this.getdate();
    },
};
</script>
